import React, { useState, useEffect } from "react";
import { Toast } from "../../Components";
import TamaCoinMain from "./TamaCoinMain";

import TamaCoinEdit from "./TamaCoinAdd/TamaCoinEdit";
import TamaCoinAdd from "./TamaCoinAdd/TamaCoinAdd";
import {
 tamacoinService
} from '../../Services';
import { utils } from "../../Helpers/utils";
export default function TamaCoin({ setAuth, setModal, NotifModul, account, profiles, setModalNotification, locationData }) {
  const [tab, setTab] = useState("main");
  const [ isLoaded,setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [toastList, setToastList] = useState([]);
  const [pageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});

  const [activityData, setActivityData] = useState([]);
  const [tabData, setTabData] = useState({});
  const [selectDesc, setSelectDesc] = useState("coin");
  const [searchText, setSearchText] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  const changeMediumDesc = (item) => {
    setSelectDesc(item.id);
    setPage(1);
    setSearchText("");
    setSearchTrigger(prev => prev + 1);
  };

  const addToast = (data) => {
    setToastList(prev => [...prev, { ...data, id: `${Date.now()}-${prev.length}` }]);
  };

  const triggerSearch = () => {
    setPage(1);
    setSearchTrigger(prev => prev + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoaded(false);
        let filter = "";
        
        if (searchText) {
          filter = `filter[${selectDesc}]=${searchText}`;
        }

        const res = await tamacoinService.getAll({
          page,
          pageSize,
          filter
        });

        setPaginationData(res.meta?.pagination || {});
        setActivityData(res.data || []);
      } catch (err) {
        console.log(err.message)
        // addToast({
        //   error: true,
        //   msg: err.message || "An error occurred",
        // });
      } finally {
        setIsLoaded(true);
      }
    };

    if (tab === "main") {
      fetchData();
    }
  }, [tab, page, searchTrigger, pageSize, selectDesc, searchText]);

  const downloadCsv = async () => {
    try {
      let filter = "";
      if (searchText) {
        filter = `filter[${selectDesc}]=${searchText}`;
      }

      const response = await tamacoinService.getAll({
        page,
        pageSize,
        filter,
        fileType: 'csv'
      });
      
      utils.downloadFile(response, "adminNotification_" + page + ".csv");
    } catch (err) {
      addToast({
        error: true,
        msg: err.message || "Failed to download CSV",
      });
    }
  };

  const setSearchTextOnChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    setTab("main");
    setSelectDesc("coin");
    setPage(1);
    setSearchText("");
  }, [locationData.key]);

  return (
    <>
      <div className="main">
        <div className="main__inner">
          {tab === "main" && (
            <TamaCoinMain
              downloadCsv={downloadCsv}
              onPaginate={setPage}
              paginationData={paginationData}
              setTab={setTab}
              setTabData={setTabData}
              tabData={activityData}
              setSearchTextOnChange={setSearchTextOnChange}
              changeMediumDesc={changeMediumDesc}
              search={triggerSearch}
              searchText={searchText}
            />
          )}

          {tab === "add" && (
            <TamaCoinAdd
              tab={tab}
              setTab={setTab}
              addToast={addToast}
            />
          )}

          {tab === "edit" && tabData.activity && (
            <TamaCoinEdit
              setTab={setTab}
              tab={tab}
              tabData={tabData}
              addToast={addToast}
            />
          )}
        </div>
      </div>

      <Toast type="rate" list={toastList} setList={setToastList} />
    </>
  );
}
